const formImport = $('#formSyncExcel');

if (formImport.length) {
  formImport.on('submit', function (event) {
    event.preventDefault();

    var $this = $(this);
    var buttonSubmit = $this.find('button[type="submit"]');
    var iFrame = $this.find('iframe.frame-progress-bar');
    var fileInfo = $this.find('.form-group.fileinfo');

    const buttonClicked = () => {
      buttonSubmit.prop('disabled', true);
      buttonSubmit.find('i,svg').css('display', 'inline-block');
      buttonSubmit.find('span').text('Carregando...');
      iFrame.css('display', 'block');
      fileInfo.css('display', 'none');
    };

    buttonClicked();

    $.ajax({
      url: formImport.prop('action'),
      type: 'PUT',
      data: formImport.serialize(),
      contentType: false,
      processData: false,
      success: function (response) {
        if (response.success) {


          Swal.fire({
            title: 'Importação realizada com sucesso!',
            text: response.message,
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Ok',
          }).then((result) => {
            if (result.isConfirmed) {
              // Redirecionar apenas quando "Ok" for clicado
              location.href = '/';
            }
          });
        } else {
          Swal.fire({
            title: 'Erro na importação!',
            text: response.message,
            icon: 'error',
            confirmButtonText: 'Fechar'
          });
        }
      },
      error: function (xhr, status, error) {
        let errorMessage = `Erro: ${xhr.status} - ${xhr.statusText}`;
        console.log(xhr, status, error);
      },
    });

    return false;
  })
}
